// Seller identity for the pre-contractual disclosures EU consumer law
// requires (Consumer Rights Directive Art 6(1) before the guest is bound,
// Art 8(2) directly above the checkout order button — see book.$holdId.tsx).
//
// OH-91 will later source these from site-config in the PMS admin; until
// that lands, this module is the SINGLE place these values are written — do
// not scatter the strings across components.
export const company = {
  name: 'Ollio Hospitality DOO Beograd',
  address: 'Kneza Miloša 15, 11000 Belgrade, Serbia',
  // matični broj
  registrationNumber: '22099345',
  // PIB
  taxNumber: '114979308',
  bookingsEmail: 'welcome@ollio.place',
  legalEmail: 'legal@ollio.place',
  phone: '+381 69 527 0222',
} as const;
